import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { CheckItem } from "../../../../components/checkbox-block/checkbox-block.component";
import { ModalService } from "../../../../services/modal.service";
import { ClaimCheckBoxItem, ClaimItemDto, PaymentDetailInfoDto, PaymentRefundRequestDto } from "../../models/payment.models";
import { Subscription } from "rxjs";
import { PaymentDetailInfoService } from "../../services/payment-detail-info.service";
import { Router } from "@angular/router";
import { PaymentDataService } from "../../services/payment-data-service.service";
import { NgxFileDropEntry } from "ngx-file-drop";
import { FileNameAndBase64 } from "../../../support/models/support.models";
import { FilesToStringService } from "../../../../services/files-to-string.service";
import { TableSwitch } from "src/app/components/switch-table/switch-table.component";
@Component({
	selector: "app-return-payment-dialog",
	templateUrl: "./return-payment-dialog.component.html",
	styleUrls: ["./return-payment-dialog.component.scss"],
})
export class ReturnPaymentDialogComponent implements OnInit, OnDestroy {
	@Output() p2pRefundEvent: EventEmitter<void> = new EventEmitter<void>();
	@Output() refundSuccessEvent: EventEmitter<void> = new EventEmitter<void>();
	@Output() fileNotLoadedEvent: EventEmitter<void> = new EventEmitter<void>();
  showValidation = false;

	id = "";
	currency = "";
	name = "";
	comment = "";

	info: PaymentDetailInfoDto | undefined;

	cardMerchant = false;
	externalSystem = false;

	allClaims: CheckItem = {
		id: 0,
		name: "ALL_CLAIMS",
		state: false,
	};

	claimsFullCommission: TableSwitch = { state: false, id: "1" };

	claimsList: ClaimCheckBoxItem[] = [];
	dtoClaimsList: ClaimItemDto[] = [];
	selectedClaimsId: number[] = [];
	totalClaimSum: number = 0;

	subs: Subscription[] = [];

	isSending = false;

	public files: NgxFileDropEntry[] = [];

	constructor(
		private modalService: ModalService,
		private paymentDetailInfoService: PaymentDetailInfoService,
		private paymentDataService: PaymentDataService,
		private router: Router,
		private filesToStringService: FilesToStringService
	) {}

	ngOnInit() {
		this.initData();
		this.initModal();
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	initData() {
		this.subs.push(
			this.paymentDetailInfoService.paymentDetail$.subscribe({
				next: (res) => {
					this.info = res;
					this.id = res.id.toString();
					this.currency = res.currency;
					this.name = res.full_name;
					this.dtoClaimsList = res.claims;
					this.setClaims();
				},
			})
		);
	}

	setClaims() {
		this.totalClaimSum = 0;
		this.claimsList = [];
		this.selectedClaimsId = [];
		this.allClaims.state = false;
		this.totalClaimSum = 0;
		this.claimsList = this.dtoClaimsList.map((el) => this.mapDtoToCheckBoxUnit(el));
	}

	initModal() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => {
					if (!res) {
						this.info = undefined;
						this.clearForm();
					}
				},
			})
		);
	}

	mapDtoToCheckBoxUnit(item: ClaimItemDto) {
		const result: ClaimCheckBoxItem = {
			id: item.id,
			name: item.infoline ? item.infoline : null,
			state: false,
			isDisabled: item.is_refund,
			sum: this.claimsFullCommission.state ? item.sum_with_commissions : item.sum_without_commissions,
		};

		return result;
	}

	toggleAllClaims(item: CheckItem) {
		this.claimsList.filter((el) => !el.isDisabled).map((el) => (el.state = item.state));

		const selectedClaims = this.claimsList.filter((el) => el.state);
		this.totalClaimSum = selectedClaims.reduce((acc, el) => acc + el.sum, 0);

		if (item.state) {
			selectedClaims.map((el) => this.selectedClaimsId.push(el.id));
		} else {
			this.selectedClaimsId = [];
		}
	}

	toggleClaim(item: CheckItem) {
		const claim = this.claimsList.find((claimItem) => claimItem.id === item.id);
		claim!.state = item.state;

		const selectedClaims = this.claimsList.filter((el) => el.state);
		this.totalClaimSum = selectedClaims.reduce((acc, el) => acc + el.sum, 0);
		this.allClaims.state = selectedClaims.length === this.claimsList.length;

		if (item.state) {
			this.selectedClaimsId.push(item.id);
		} else {
			this.selectedClaimsId = this.selectedClaimsId.filter((el) => el !== item.id);
		}

		this.allClaims.state = this.claimsList.filter((claimItem) => !claimItem.isDisabled).every((claimItem) => claimItem.state);
	}

	get validateForm(): boolean {
		return !!this.id.trim() && !!this.totalClaimSum && !!this.comment.trim() && !!this.name.trim();
	}

	// get readOnlyName(): boolean {
	//   return (this.cardMerchant.state && !this.externalSystem.state) || (!this.cardMerchant.state && !this.externalSystem.state);
	// }

	closeModal() {
		this.clearForm();
		this.modalService.closeModal();
	}

	clearForm() {
		this.id = "";
		this.currency = "";
		this.name = "";
		this.comment = "";

		this.claimsList = [];
		this.selectedClaimsId = [];
		this.totalClaimSum = 0;
		this.claimsFullCommission.state = false;

		this.allClaims.state = false;

		this.cardMerchant = false;
		this.externalSystem = false;

		this.files = [];
    this.showValidation = false;
	}

	setRefundType(type: string) {
		if (type === "fromTransitAccount") {
			this.externalSystem = false;
			this.cardMerchant = false;
		}

		if (type === "externalSystems") {
			this.externalSystem = true;
			this.cardMerchant = false;
		}

		if (type === "fromCard") {
			this.externalSystem = false;
			this.cardMerchant = true;
		}
	}

  sendFormData() {
    this.showValidation = true;

    if (!this.validateForm || this.files.length === 0 || !this.selectedClaimsId.length) {
      return;
    }

    this.isSending = true;
    let files: FileNameAndBase64[] = [];
    let data: PaymentRefundRequestDto;

    this.filesToStringService.toFilesBase64(this.files).subscribe({
      next: (res) => {
        files = res;
        data = {
          RefundRequest: {
            files: files,
            refund_amount: this.totalClaimSum,
            full_name: this.name,
            payment_purpose: this.comment,
            is_external: this.externalSystem,
            is_refund_from_card: this.cardMerchant,
            agent_id: this.info!.agent_id,
            payment_id: this.info!.id,
            claim_id_list: this.selectedClaimsId,
            with_commission: this.claimsFullCommission.state,
          },
        };
        this.createRefund(data);
      },
    });
  }

	createRefund(data: PaymentRefundRequestDto) {
		this.paymentDataService.refundRequestCall(data).subscribe({
			next: (res) => {
				this.isSending = false;

				if (this.externalSystem) {
					this.modalService.closeModal();
					this.refundSuccessEvent.emit();
					return;
				}

				if (res.p2pRefundToken && !this.cardMerchant) {
					this.p2pRefundEvent.emit();
					return;
				}

				if (!res.p2pRefundToken && !this.cardMerchant) {
					this.modalService.closeModal();
					this.refundSuccessEvent.emit();
					return;
				}

				if (res.p2pRefundToken && this.cardMerchant) {
					this.router.navigate(["/payment-to-card"], {
						queryParams: {
							name: this.info?.full_name,
							id: this.id,
							sum: this.totalClaimSum,
							currency: this.currency,
							comment: this.comment,
							token: res.p2pRefundToken,
						},
					});
					this.modalService.closeModal();
				}
			},
			error: () => {
				this.isSending = false;
			},
		});
	}

	dropped(files: NgxFileDropEntry[]) {
		for (const droppedFile of files) {
			const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
			fileEntry.file((file: File) => {
				const type = file.name.substring(file.name.lastIndexOf(".") + 1);

				const allowedTypes = ["jpg", "jpeg", "bmp", "gif", "png", "doc", "docx", "pdf", "xlsx", "xls", "rar", "zip"];
				if (file.size / 1048576 <= 10 && this.files.length <= 4 && allowedTypes.includes(type.toLocaleLowerCase())) {
					this.files.push(droppedFile);
				} else {
					this.fileNotLoadedEvent.emit();
				}
			});
		}
	}

	public fileOver(event: any) {
		// console.log(event);
	}

	public fileLeave(event: any) {
		// console.log(event);
	}

	deleteFile(index: number) {
		this.files.splice(index, 1);
	}

}
